import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../../Pages/Public/Login";

const PublicRoutes = ({ setUser }) => {
  return (
    <Routes>
      <Route path="/login" element={<Login setUser={setUser} />} />

      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default PublicRoutes;
